import { AxiosInstance } from 'axios';
import { PlayerCard } from '../constants';

const getCardServices = ({ GateWayInstance }: { GateWayInstance: AxiosInstance }) => ({
  getCards(aid: string) {
    return GateWayInstance.get<PlayerCard>(`/players/card/${aid}`);
  },
  updateCard(aid: string, data: Partial<PlayerCard>) {
    return GateWayInstance.put(`/players/card/${aid}`, data);
  },
});

export default getCardServices;
